module.exports = __webpack_public_path__ + "static/media/Betina G.228dbc27.jpeg";